import { FC } from 'react';
import { StyleProp, ViewStyle } from 'react-native';

import { InvoiceData } from '../../types/TransactionDetail';
import { DataItemConfigs } from './RenderConfig';
import S from './styles';

interface Props {
  invoiceData: Partial<InvoiceData>;
  testID?: string;
  wrapperStyle?: StyleProp<ViewStyle>;
}

const Receipt: FC<Props> = ({ invoiceData, wrapperStyle }) => {
  const dataWithDefault = {
    id: '',
    created_at: 0,
    buyer_identifier: '',
    buyer_name: '',
    ...invoiceData,
  };

  const makeDataItem = ({
    title,
    value,
    name,
  }: {
    title: string;
    value: string;
    name: string;
  }) => (
    <S.DataItem key={name} testID={name}>
      <S.Title>{title}</S.Title>
      <S.Value>{value}</S.Value>
    </S.DataItem>
  );

  // Make DataItem from data by config
  const renderData = DataItemConfigs.reduce((result: JSX.Element[], config) => {
    const { name, getTitle, isValidate, formatValue } = config;
    const dataValue = dataWithDefault[name];
    const validate = isValidate(dataValue);

    if (validate) {
      const title = getTitle();
      const value = formatValue(dataValue);
      const dataItem = makeDataItem({ name, title, value });

      result.push(dataItem);
    }

    return result;
  }, []);

  return (
    <S.Receipt style={wrapperStyle}>
      <S.Container>{renderData}</S.Container>
      <S.Barcode source={require('./assets/Barcode.png')} />
    </S.Receipt>
  );
};

export default Receipt;
